import { render } from "./BaseTab.vue?vue&type=template&id=6e238064&scoped=true"
import script from "./BaseTab.vue?vue&type=script&lang=js"
export * from "./BaseTab.vue?vue&type=script&lang=js"

import "./BaseTab.vue?vue&type=style&index=0&id=6e238064&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e238064"]])

export default __exports__